export const reactSelectStyles = {
	control: (provided: any) => ({
		...provided,
		background: 'transparent',
		borderRadius: 0,
		borderColor: 'inherit',
		minHeight: '40px',
	}),
	menu: (provided: any) => ({
		...provided,
		background: 'white',
		color: 'black',
		zIndex: 9999,
		borderRadius: 0,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
		marginTop: '4px',
	}),
	menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
	menuList: (provided: any) => ({
		...provided,
		padding: '4px 0',
		maxHeight: '300px',
	}),
	option: (provided: any, state: any) => ({
		...provided,
		backgroundColor: state.isFocused ? '#f5f5f5' : state.isSelected ? '#e0e0e0' : 'white',
		color: state.isFocused || state.isSelected ? 'black' : 'inherit',
		padding: '10px 12px',
		cursor: 'pointer',
		'&:active': { backgroundColor: '#e0e0e0' },
	}),
	multiValue: (provided: any) => ({ ...provided, background: 'transparent' }),
	multiValueLabel: (provided: any) => ({ ...provided, color: 'inherit', padding: '2px 6px' }),
	multiValueRemove: (provided: any) => ({
		...provided,
		color: 'inherit',
		cursor: 'pointer',
		'&:hover': { backgroundColor: 'transparent', color: 'inherit', opacity: 0.7 },
	}),
	clearIndicator: (provided: any) => ({
		...provided,
		color: 'inherit',
		cursor: 'pointer',
		'&:hover': { color: 'inherit', opacity: 0.7 },
	}),
	dropdownIndicator: (provided: any) => ({
		...provided,
		color: 'inherit',
		cursor: 'pointer',
		'&:hover': { color: 'inherit', opacity: 0.7 },
	}),
	indicatorSeparator: (provided: any) => ({ ...provided, backgroundColor: 'currentColor', opacity: 0.3 }),
	placeholder: (provided: any) => ({ ...provided, color: 'inherit', opacity: 0.6 }),
	input: (provided: any) => ({ ...provided, color: 'inherit' }),
	valueContainer: (provided: any) => ({ ...provided, padding: '2px 8px' }),
};
